/**
 * 二手车新市场代办业务信息统一到这里显示
 */
import React from 'react';

import { Input, Row, Col, DatePicker, Select, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

//加载中遮罩
import Loading from '../../ui/Loading';
import messager from '../../ui/messager';
import http from '../../../axios/http';

class TradeAgentSumIndex extends React.Component {

    deductionTypeArray = [{
        code: 12,
        text: "代办业务",
    }, {
        code: 14,
        text: "新车上牌",
    }, {
        code: 15,
        text: "其他业务",
    }];

    customerSourceArray = [{
        code: 1,
        text: "市场会员",
    }, {
        code: 2,
        text: "直接客户",
    }];

    columns = [{
        title: '创建时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '客户来源',
        dataIndex: 'memberName',
        width: '10%',
        // format: { 1: '市场会员', 2: '直接客户', 3: '其他' }
    }, {
        title: '业务类型',
        dataIndex: 'businessType',
        width: '10%',
        format: { 12: "过户业务", 14: '新车上牌', 15: '其他业务' }
    }, {
        title: '车型',
        dataIndex: 'brandModel',
        width: '10%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '10%',
    }, {
        title: '新车主',
        dataIndex: 'buyer',
        width: '10%',
    }, {
        title: '原车牌',
        dataIndex: 'plateNo',
        width: '10%',
    }, {
        title: '新车牌',
        dataIndex: 'newPlateNo',
        width: '10%',
    }, {
        title: '费用',
        dataIndex: 'actualComission',
        width: '10%',
    }, {
        title: '到账时间',
        dataIndex: 'collectionTime',
        width: '10%',
    }, {
        title: '录单员',
        dataIndex: 'operator',
        width: '10%',
    }, {
        title: '接单员',
        dataIndex: 'grabUser',
        width: '10%',
    }];

    state = {
        queryData: {}, //查询数据
        loadingVisible: false,
    };





    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value
        this.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.loadData(queryData);
    }

    selectChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.loadData(queryData);
    }
    
    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNo = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/tradeAgentSum/downloadAgentSum',
            data: queryData,
            fileName: "代办业务明细.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车牌号/车架号"
                                    onSearch={this.inputSearch.bind(this,"vinOrPlateNo")}
                                    enterButton
                                    style={{ width: '150px' }}
                                />
                                 <Input.Search
                                    placeholder="录单员"
                                    onSearch={this.inputSearch.bind(this,"operator")}
                                    enterButton
                                    style={{ width: '150px', marginLeft: '10px'  }}
                                />
                                 <Input.Search
                                    placeholder="接单员"
                                    onSearch={this.inputSearch.bind(this,"grabUser")}
                                    enterButton
                                    style={{ width: '150px', marginLeft: '10px'  }}
                                />
                                <Input.Search
                                    placeholder="客户"
                                    onSearch={this.inputSearch.bind(this,"memberName")}
                                    enterButton
                                    style={{ width: '150px', marginLeft: '10px'  }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ margin: '0 10px' }} />
                                <Select onChange={this.selectChange.bind(this, "businessType")} allowClear={true} style={{ width: 180, margin: '0 10px' }}>
                                    {this.deductionTypeArray.map(d => <Select.Option key={d["code"]}>{d["text"]}</Select.Option>)}
                                </Select>
                                {/* <Select onChange={this.selectChange.bind(this, "customerSource")} allowClear={true} style={{ width: 180, margin: '0 10px' }}>
                                    {this.customerSourceArray.map(d => <Select.Option key={d["code"]}>{d["text"]}</Select.Option>)}
                                </Select> */}
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="applicationId"
                    url="/tradeAgentSum/pageAgentSum"
                    columns={this.columns}
                    loadData={(func) => { this.loadData = func }}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中"
                />
            </div>
        )
    }

}

export default TradeAgentSumIndex;